
define( 'system/js/autocomplete',[ 'jclass', 'jquery', 'typeahead', 'bloodhound' ], function( Class, $ ) {
	'use strict';

	/*
	===============================================================================
	Class: Autocomplete
	===============================================================================
	*/

	var Autocomplete = Class._extend( {

		/**
		 * Method: init
		 * @param {Object} aOptions
		 */

		init: function( aOptions ) {
			var options = aOptions || { };

			this._options = $.extend( true, {
				input: false,
				hints: false,
				emptyMessage: 'No results found',
				placeholder: false,
				defaultToPlaceholder: true,
				selectFirstValue: false,
				prepend: false,
				parent: false,
				icons: {
					client: 'svg-person',
					company: 'svg-companydetails',
					tag: 'svg-tag',
					team: 'svg-team',
					search: 'svg-search'
				},
				// Arrays allowed for broader searches, first item becomes the label/value.
				maps: {
					client: 'display_name',
					company: 'company_name',
					plan: 'display_name',
					fee: 'title',
					image: 'label',
					proposal: [ 'name', 'number' ],
					template: 'name',
					section: 'name',
					snippet: 'name',
					tag: 'name',
					team: 'name',
					user: 'display_name',
					search: 'label',
					proposify_fields: 'name'
				},
				data: { },
				display: { },
				select: function( aValue ) { },
				open: function( ) { },
				templates: {
					suggestion: false
				},
				appendTo: false,
				strictSelection: false,
				itemClassPrefix: '',
				clear_search_button: false,
				clear_search_class: '',
				search: {
					enable: false,
					url: false,
					searchMessage: 'Searching...',
					notFoundMessage: 'Not Found',
					mapResponse: { },
					success: function( aResponse ) { },
					error: function( aResponse ) { },
					// For more-responsive AJAX-only requests, set bloodhound to false
					bloodhound: true,
					limit: 50
				},
				searchById: {
					enable: false,
					url: false,
					dataContainer: '',
					dataTarget: '',
					dataMethod: ''
				}
			}, options );

			this.$input = $( this._options.input );
			this._input = this.$input[ 0 ];

			if ( this.$input.length === 0 ) {
				this.$input = null;

				return this;
			}

			this.$container = this.$input.parent( );
			this._container = this.$container[ 0 ];

			this._parent = this._options.parent;

			this.$cache = false;
			this._cache = false;
			this.$menu = false;
			this._suggestion = false;

			this._typeahead = false;
			this.$typeahead = false;

			this._labels = [ ];
			this._source = false;
			this._converted = false;
			this._preselected = false;
			this._wrapper = false;

			if ( this._input.tagName.toLowerCase( ) === 'select' && this._input.hasAttribute( 'multiple' ) === true ) {
				this._preselected = this.$input.val( );

				this._convertSelect( this._input.getAttribute( 'placeholder' ) );
				this._input.value = '';
			}
			else if ( this._input.tagName.toLowerCase( ) === 'select' ) {
				this._options.data = this._readOptions( this._input );
				this._options.hints = true;

				this._convertSelect( ( this._input.selectedIndex !== -1 ) ? this._input.options[ this._input.selectedIndex ].innerHTML : '' );

				this._converted = true;
			}

			this._setData( this._options.data );

			this._placeholder = this._options.placeholder || this._input.getAttribute( 'placeholder' );
			this._className = this._input.className;

			this._create( );
			this._bind( );

			this._selectionEnabled = this._options.selectFirstValue;
			this._defaultKey = this._cache.getAttribute( 'name' );

			if ( parseInt( this._cache.value, 10 ) > 0 || this._cache.value ) {
				this.select( this._cache.value );
			}

			this._selectionEnabled = true;

			this._templates = this._options.templates;

			return this;
		},

		/**
		 * Converts a select to a text input
		 *
		 * @param  {String}  aPlaceholder
		 */

		_convertSelect: function( aPlaceholder ) {
			var placeholder = aPlaceholder || '',
				input = document.createElement( 'input' );

			if ( this._input.getAttribute( 'id' ) !== null ) {
				input.setAttribute( 'id', this._input.getAttribute( 'id' ) );
			}

			input.setAttribute( 'name', this._input.getAttribute( 'name' ).replace( /\[.*\]/, '' ) );
			input.setAttribute( 'type', 'text' );
			input.setAttribute( 'placeholder', this._encode( placeholder ) );
			input.setAttribute( 'autocomplete', 'off' );
			input.className = this._input.className;
			input.value = this.$input.val( );

			$( input ).copyDataSet( this.$input );

			this.$input.replaceWith( input );

			this._input = input;
			this.$input = $( input );
		},

		/**
		 * Method: _readOptions
		 * @param {DOMelement} aElement
		 */

		_readOptions: function( aElement ) {
			var options = [ ],
				i, len, node, optgroup, optgroupLabel;

			if ( $.isElement( aElement ) && aElement.tagName.toLowerCase( ) === 'optgroup' ) {
				optgroupLabel = aElement.getAttribute( 'label' );
			}

			for ( i = 0, len = aElement.childNodes.length; i < len; i++ ) {
				node = aElement.childNodes[ i ];

				if ( node.tagName.toLowerCase( ) === 'option' ) {
					options.push( {
						value: node.value,
						label: node.innerHTML,
						class: node.getAttribute( 'data-class' ) || '',
						icon: node.getAttribute( 'data-icon' ) || 'hidden',
						display: node.getAttribute( 'data-display' ) || node.innerHTML,
						extra: node.getAttribute( 'data-extra' ) || '',
						optgroup: false,
						optgroupLabel: optgroupLabel,
						selectable: true,
						dataset: $.getDataSet( node )
					} );
				}
				else if ( node.tagName.toLowerCase( ) === 'optgroup' ) {
					optgroup = {
						label: node.getAttribute( 'label' ),
						display: node.getAttribute( 'data-display' ) || node.getAttribute( 'label' ),
						optgroup: true,
						data: this._readOptions( node ),
						dataset: $.getDataSet( node )
					};

					if ( node.hasAttribute( 'data-value' ) === true ) {
						optgroup.value = node.getAttribute( 'data-value' );
						optgroup.selectable = true;
					}

					if ( node.hasAttribute( 'data-key' ) === true ) {
						optgroup.key = node.getAttribute( 'data-key' );
					}

					options.push( optgroup );
				}
			}

			return options;
		},

		/**
		 * Method: _create
		 */

		_create: function( ) {
			var name = this._input.getAttribute( 'name' );

			this._cache = document.createElement( 'input' );
			this.$cache = $( this._cache );

			this.$cache.copyDataSet( this.$input );

			this._cache.setAttribute( 'name', name );
			this._cache.setAttribute( 'type', 'hidden' );
			this._cache.setAttribute( 'autocomplete', 'off' );
			this._cache.value = this._input.value;

			if ( this._input.value.length > 0 && this._options.defaultToPlaceholder === true ) {
				this._input.setAttribute( 'placeholder', this._encode( this._input.value ) );
				this._input.value = '';
			}

			this._input.setAttribute( 'name', name + '-typeahead' );

			this._container.appendChild( this._cache );
		},

		/**
		 * Method: _setData
		 */

		_setData: function( aData ) {
			var i, len, options;

			this._labels = [ ];

			if ( this._converted === true ) {
				for ( i = 0, len = aData.length; i < len; i++ ) {
					options = $.extend( true, {
						class: '',
						icon: 'hidden',
						value: -1,
						label: '',
						key: this._defaultKey,
						extra: '',
						selectable: false,
						optgroup: true
					}, aData[ i ] );

					this._labels.push( options );

					if ( aData[ i ].hasOwnProperty( 'data' ) ) {
						this._appendData( aData[ i ].data, options.label );
					}
				}
			}
			else {
				this._appendData( aData );
			}
		},

		/**
		 * Method: _appendData
		 */

		_appendData: function( aData, aOptgroup ) {
			var i, j, len, k, len2, maps, label, extra;

			for ( i in aData ) {
				if ( this._converted === true ) {
					this._labels.push( aData[ i ] );
				}
				else if ( this._options.maps.hasOwnProperty( i ) ) {
					for ( j = 0, len = aData[ i ].length; j < len; j++ ) {
						maps = this._options.maps[ i ];

						if ( Array.isArray( maps ) ) {
							label = aData[ i ][ j ][ maps[ 0 ] ];

							for ( k = 1, len2 = maps.length; k < len2; k++ ) {
								if ( k === 1 ) {
									extra = aData[ i ][ j ][ maps[ k ] ];
								}
								else {
									extra += ' ' + aData[ i ][ j ][ maps[ k ] ];
								}
							}
						}
						else {
							label = aData[ i ][ j ][ maps ];
							extra = null;
						}

						this._labels.push( {
							icon: ( this._options.icons.hasOwnProperty( i ) === true ) ? this._options.icons[ i ] : 'hidden',
							value: ( this._options.hints === true ) ? aData[ i ][ j ].id : label,
							label: label,
							display: ( this._options.display.hasOwnProperty( i ) === true ) ? aData[ i ][ j ][ this._options.display[ i ] ] : label,
							optgroup: false,
							selectable: true,
							optgroupLabel: aOptgroup,
							extra: extra
						} );
					}
				}
			}
		},

		/**
		 * Method: _bind
		 */

		_bind: function( ) {
			var min, tpl, span, icon, prepend, c,
				item_class = '',
				self = this;

			if ( this._options.hints === true ) {
				this.$input.addClass( 'dropdown' );

				min = 0;

				if ( this._options.templates.suggestion === false ) {
					tpl = {
						empty: '<div class="empty-message">' + this._options.emptyMessage + '</div>',
						suggestion: function( aItem ) {
							if ( aItem.optgroup === true && aItem.selectable === true ) {
								return '<div class="optgroup" data-value="' + aItem.value + '"><span class="svg ' + aItem.icon + '"></span><span class="role-label">' + aItem.label + '</span></div>';
							}
							else if ( aItem.optgroup === true && aItem.selectable === false ) {
								return '<div class="optgroup disabled" data-value="' + aItem.value + '"><span class="svg ' + aItem.icon + '"></span><span class="role-label">' + aItem.label + '</span></div>';
							}
							else {
								if ( typeof $.slugify === 'function' && aItem.hasOwnProperty( 'class' ) === true ) {
									item_class = $.slugify( aItem.class );
								}

								return '<div class="' + item_class + '" data-value="' + aItem.value + '"><span class="svg ' + aItem.icon + '"></span><span class="role-label">' + aItem.label + '</span></div>';
							}
						}
					};
				}
				else {
					tpl = {
						empty: '<div class="empty-message">' + this._options.emptyMessage + '</div>',
						suggestion: self._options.templates.suggestion
					};
				}
			}
			else {
				if ( this._preselected === false ) {
					this.$input.addClass( 'search' );
				}

				tpl = {
					suggestion: function( aItem ) {
						return '<div><span class="svg ' + aItem.icon + '"></span><span class="role-label">' + aItem.label + '</span></div>';
					}
				};

				min = 1;
			}

			this.$input.typeahead( {
				hints: true, // TODO this is not the right key name: 'hint' (https://github.com/twitter/typeahead.js/blob/master/doc/jquery_typeahead.md#options)
				highlight: true,
				classNames: {
					input: 'tt-input no-overflow overflow-ellipsis',
					menu: 'tt-menu' + ( ( this._options.search.bloodhound === false ) ? ' tt-test' : '' ),
					item: this._options.itemClassPrefix
				},
				minLength: min
			}, {
				name: 'all',
				limit: this._options.search.limit || this._labels.length,
				source: this._getCallback( ),
				templates: tpl,
				display: 'label'
			} );

			this._input.setAttribute( 'autocomplete', 'off' );

			this.$typeahead = this.$input.closest( '.twitter-typeahead' );
			this._typeahead = this.$typeahead[ 0 ];

			// Add clear button
			if ( this._options.clear_search_button === true ) {
				c = ( this._input.value === '' ) ? ' hidden' : '';
				c += ' ' + this._options.clear_search_class;

				this.$typeahead.append( '<a href="#" class="form-control-feedback clear-search' + c + '"><span class="svg svg-x text-muted"></span></a>' );
			}

			if ( this._preselected !== false ) {
				this._prependTags( );
			}

			this.$menu = this.$typeahead.find( '> .tt-menu' );
			this.$menu.css( 'width', '100%' );
			this.$menu.find( '> .tt-dataset' ).isolatedScroll( );

			this.$input.siblings( '.tt-hint' ).attr( 'class', 'tt-hint' );

			this.$input.on( 'typeahead:autocomplete typeahead:select', function( aEvent, aSuggestion, aOptions ) {
				var label = aSuggestion.display || '',
					key = aSuggestion.key || self._defaultKey,
					old = self._cache.value,
					options = aOptions || { },
					val;

				if ( ( aSuggestion.hasOwnProperty( 'selectable' ) === true && aSuggestion.selectable === false ) || ( self._options.strictSelection === true && aSuggestion.hasOwnProperty( 'selectable' ) === false ) ) {
					return false;
				}
				else {
					if ( !aSuggestion.value && aSuggestion.value !== 0 ) {
						val = '';
					}
					else {
						val = $.trim( aSuggestion.value );
					}

					if ( self._preselected !== false ) {
						if ( self._hasTag( val ) === false ) {
							self._addTag( val );

							self.$input.typeahead( 'val', '' );
							self.$cache.val( val );

							if ( self._selectionEnabled === true ) {
								$.proxy( self._options.select, self )( val );
							}
						}
					}
					else if ( ( options.hasOwnProperty( 'checkValue' ) && options.checkValue === false ) || val !== old ) {
						self._setSelection( aSuggestion );

						if ( self._options.hints === true ) {
							self.$input.trigger( 'blur.tt' );

							self._input.setAttribute( 'placeholder', self._encode( label ) );
							self.$input.val( self._encode( label ) );
						}
						else if ( val !== old && self._options.wrapValue !== false && ( options.hasOwnProperty( 'wrapValue' ) === false || ( options.hasOwnProperty( 'wrapValue' ) && options.wrapValue === true ) ) ) {
							val = '"' + val + '"';
						}

						self._cache.setAttribute( 'name', key );
						self._cache.value = val;

						if ( self._selectionEnabled === true ) {
							if ( aSuggestion.id === undefined ) {
								$.proxy( self._options.select, self )( val );
							}
							else {
								self._searchById( aSuggestion.id, aSuggestion.entity );
							}
						}
					}
					else if ( val === old && self._options.hints === true ) {
						self._input.setAttribute( 'placeholder', self._encode( label ) );
					}

					// After selecting an option blur and reflect the actual search term in the input field,
					// show "" if the whole phrase is considered
					// Fix for: https://proposify2.atlassian.net/browse/P2X-2958
					self.$input.trigger( 'blur.tt' );

					if ( val[ 0 ] === '"' && val[ val.length - 1 ] === '"' ) {
						self.$input.typeahead( 'val', val );
					}
				}
			} );

			this.$input.on( 'typeahead:open', function( aEvent ) {
				var offset, modal,
					cb = function( ) {
						self.$input.trigger( 'blur.tt' );
					};

				// Only automatically clear input when there's no clear_search_button
				if ( self._options.clear_search_button === false ) {
					self.$input.typeahead( 'val', '' );
				}

				self.$input.addClass( 'tt-input-focus' );
				self.$input.elementBlur( cb, self.$menu );

				self._setSelectionPosition( );

				if ( self._options.appendTo !== false ) {
					offset = self.$input.offset( );

					self.$menu.css( {
						left: offset.left,
						top: offset.top + self.$input.outerHeight( true ) - $( window ).scrollTop( ),
						width: self.$input.outerWidth( )
					} );

					modal = self.$input.closest( 'div.modal-body' );

					if ( modal.length > 0 ) {
						modal.one( 'scroll.Autocomplete', function( aEvent ) {
							self.$input.trigger( 'blur.tt' );
						} );
					}
				}

				$.proxy( self._options.open, self )( );
			} );

			this.$input.on( 'typeahead:render', function( aEvent ) {
				self._setSelectionPosition( );

				if ( self._options.appendTo !== false ) {
					self.$menu.appendTo( self._options.appendTo );
					self.$menu.addClass( 'fixed' );
				}
			} );

			if ( this._options.hints === true ) {
				this.$input.on( 'typeahead:close', function( aEvent ) {
					var val = self.$input.typeahead( 'val' ),
						cur = self._cache.value;

					if ( val !== cur ) {
						self.$input.typeahead( 'val', '' );
					}

					self.$input.removeClass( 'tt-input-focus' );
					self.$input.blur( );

					return false;
				} );
			}

			if ( this._options.clear_search_button === true ) {
				this.$typeahead.find( 'a.clear-search' ).on( 'click', function( aEvent ) {
					aEvent.preventDefault( );
					aEvent.stopPropagation( );

					$( this ).addClass( 'hidden' );
					self.clear( );

					self._options.select.call( self );
				} );
			}

			this.$input.on( 'keypress', function( aEvent ) {
				if ( aEvent.which === 13 ) {
					aEvent.preventDefault( );
					aEvent.stopPropagation( );

					if ( self._options.search.enable === true && self._options.search.bloodhound === true ) {
						self.search( this.value );
					}
					else {
						self.$input.trigger( 'typeahead:select', [ { value: this.value, label: this.value }, { wrapValue: false } ] );
					}
				}
				else if ( aEvent.which === 27 ) {
					self.$input.trigger( 'blur.tt' );
				}
			} );

			this.$input.on( 'keyup', function( ) {
				if ( self._options.clear_search_button === true ) {
					if ( this.value === '' ) {
						self.$typeahead.find( '> a.clear-search' ).addClass( 'hidden' );
					}
					else {
						self.$typeahead.find( '> a.clear-search' ).removeClass( 'hidden' );
					}
				}
			} );

			if ( this._options.hints === false && this._preselected === false ) {
				span = document.createElement( 'span' );
				span.className = 'form-control-feedback form-control-feedback-left';

				icon = document.createElement( 'span' );
				icon.className = 'svg svg-search';

				span.appendChild( icon );

				this.$input.after( span );
			}
			else if ( this._preselected !== false ) {
				this.$input.on( 'keydown.tt', function( aEvent ) {
					if ( this.value.length === 0 && aEvent.which === 8 && self._preselected !== false ) {
						self._removeTag( self.$wrapper.find( '> span.tag' ).last( ).find( '> span.svg' ) );
					}
				} );
			}

			if ( this._options.prepend !== false && $( this._options.prepend ).length > 0 ) {
				prepend = $( this._options.prepend ).clone( true );
				prepend.addClass( 'tt-prepend' );

				prepend[ 0 ].removeAttribute( 'id' );

				//Allow for elements within the typeahead to be focusable
				this.$input.off( 'blur.tt' ).on( 'blur.tt', function( aEvent ) {
					if ( !aEvent.relatedTarget || typeof aEvent.relatedTarget === 'undefined' || $( aEvent.relatedTarget ).closest( self.$menu ).length === 0 ) {
						self.$input.typeahead( 'close' );
					}
				} );

				prepend.find( 'input' ).on( 'click.tt', function( aEvent ) {
					$( this ).trigger( 'focus.tt' );
				} );

				// Fixes a Bootstrap issue that occurs when the typeahead is in a modal but the prepend is outside of the modal
				prepend.find( 'input' ).on( 'focusin.tt', function( aEvent ) {
					aEvent.preventDefault( );
					aEvent.stopPropagation( );
				} );

				prepend.find( 'input' ).on( 'blur.tt', function( aEvent ) {
					self.$input.trigger( 'blur.tt' );
				} );

				prepend.find( 'input' ).on( 'keydown', function( aEvent ) {
					if ( aEvent.keyCode === 13 ) {
						if ( prepend.find( '.btn[role="submit"]' ).length > 0 ) {
							aEvent.preventDefault( );
							aEvent.stopPropagation( );

							prepend.find( '.btn[role="submit"]' ).trigger( 'click' );
						}
					}
				} );

				this.$menu.prepend( prepend );
			}

			this.$input.data( 'autocomplete', this );
			this.$cache.data( 'autocomplete', this );
		},

		/**
		 * Prepends tag elements to the input
		 */

		_prependTags: function( ) {
			var div = document.createElement( 'div' ),
				span = document.createElement( 'span' ),
				i, len,
				self = this;

			div.className = 'bootstrap-tagsinput';
			div.setAttribute( 'data-name', this._cache.getAttribute( 'name' ) );

			span.className = 'input-wrapper';

			div.appendChild( span );

			this._typeahead.parentNode.appendChild( div );
			span.appendChild( this._typeahead );

			this._cache.setAttribute( 'name', 'typeahead-hidden' );

			this._wrapper = div;
			this.$wrapper = $( this._wrapper );

			for ( i = 0, len = this._preselected.length; i < len; i++ ) {
				this._addTag( this._preselected[ i ] );
			}

			this.$wrapper.on( 'click.tag', '.svg.svg-cancel', function( aEvent ) {
				self._removeTag( aEvent.target );
			} );
		},

		/**
		 * Add a tag element to the DOM
		 *
		 * @param  {String} aTag
		 */

		_addTag: function( aTag ) {
			var name, tag, el;

			tag = document.createElement( 'span' );
			tag.className = 'tag';

			el = document.createElement( 'span' );
			el.className = 'tag-label';
			el.textContent = aTag;

			tag.appendChild( el );

			el = document.createElement( 'span' );
			el.className = 'svg svg-cancel';
			el.setAttribute( 'data-role', 'remove' );

			tag.appendChild( el );

			name = this._wrapper.getAttribute( 'data-name' );

			if ( name.substring( name.length - 2 ) !== '[]' ) {
				name += '[]';
			}

			el = document.createElement( 'input' );
			el.className = 'hidden';
			el.setAttribute( 'name', name );
			el.setAttribute( 'value', aTag );
			el.setAttribute( 'type', 'checkbox' );
			el.setAttribute( 'checked', 'checked' );

			tag.appendChild( el );

			this._wrapper.insertBefore( tag, this._wrapper.lastChild );
		},

		/**
		 * Remove a tag from the DOM as well as its associated input element
		 *
		 * Once it's been removed, trigger a change event on the input
		 *
		 * @param  {DOMElement}  aElement
		 */

		_removeTag: function( aElement ) {
			var el = $( aElement ),
				tag = el.closest( 'span.tag' );

			tag.remove( );

			if ( this._selectionEnabled === true ) {
				$.proxy( this._options.select, this )( );
			}
		},

		/**
		 * Checks to see if a tag has already been selected
		 *
		 * @param  {String} aTag
		 *
		 * @return {Boolean}
		 */

		_hasTag: function( aTag ) {
			var tag = aTag || '',
				els = this.$wrapper.find( 'span.tag input' ),
				i, len;

			if ( tag.length > 0 ) {
				for ( i = 0, len = els.length; i < len; i++ ) {
					if ( els[ i ].value === tag ) {
						return true;
					}
				}

				return false;
			}
			else {
				return true;
			}
		},

		/**
		 * Method: _encode
		 * @param {String} aString
		 */

		_encode: function( aString ) {
			return aString.replace( /&amp;/, '&' );
		},

		/**
		 * Method: _getSource
		 * @param {Boolean} aRefresh
		 */

		_getSource: function( aRefresh ) {
			var refresh = aRefresh || false;

			if ( refresh === true || this._source === false || typeof this._source === 'undefined' ) {
				this._source = new Bloodhound( {
					datumTokenizer: function( aItem ) {
						var label = aItem.label || '',
							optgroupLabel = aItem.optgroupLabel || '',
							extra = aItem.extra || '',
							str = $.trim( label + ' ' + optgroupLabel + ' ' + extra );

						// we look to split by spaces, punctuations and new lines
						return str.split( /[\s.,!"'$]/ );
					},
					queryTokenizer: Bloodhound.tokenizers.whitespace,
					local: this._labels
				} );
			}

			return this._source;
		},

		/**
		 * Method: _getCallback
		 */

		_getCallback: function( ) {
			var self = this,
				i;

			// bloodhound: false is optimized for a responsive AJAX-only search engine
			if ( this._options.search.bloodhound === false ) {
				var debounceDelay = 300,
					callbackFunction;

				callbackFunction = function( aQuery, cbSyncResults, cbAsyncResults ) {

					//We don't need a call to backend if the user already select some suggestion
					if ( self.getSelection( ) !== false && self.getSelection( ).id !== undefined ) {
						self._clearSelection( );
						return;
					}

					self._parent.getConduit( 'typeahead-ajax' ).ajax( {
						url: self._options.search.url,
						data: {
							keywords: aQuery,
							limit: self._options.search.limit
						},
						success: function( aResponse ) {
							var final = [ ],
								data, j, len2, entity;

							// Map plural arrays (e.g. companies) in response data
							// to known entitiy types (e.g. company)
							for ( i in aResponse.data ) {
								if ( self._options.search.mapResponse.hasOwnProperty( i ) === true ) {
									entity = self._options.search.mapResponse[ i ];
									data = aResponse.data[ i ];

									// Add metadata to the response data
									for ( j = 0, len2 = data.length; j < len2; j++ ) {
										final.push( {
											icon: ( self._options.icons.hasOwnProperty( entity ) === true ) ? self._options.icons[ entity ] : 'hidden',
											value: data[ j ][ self._options.maps[ entity ] ],
											label: data[ j ][ self._options.maps[ entity ] ],
											entity: entity,
											id: data[ j ].id
										} );

										if ( final.length > self._options.search.limit - 1 ) {
											break;
										}
									}
								}
							}

							cbAsyncResults( final );

							self._clearSelection( );
							self._options.search.success.call( self, final );
						}
					} );
				};

				return $.debounce( callbackFunction, debounceDelay );
			}
			else if ( this._options.hints === true ) {
				return function( aQuery, aSync ) {
					if ( $.trim( aQuery ).length === 0 ) {
						aSync( self._labels );
					}
					else {
						self._getSource( ).search( aQuery, aSync );
					}
				};
			}
			else {
				return this._getSource( );
			}
		},

		_searchById: function( id, entity ) {
			var app = this._parent.getApp( ),
				a = document.createElement( 'a' );

			a.setAttribute( 'href', this._options.searchById.url );
			a.setAttribute( 'data-container', this._options.searchById.dataContainer );
			a.setAttribute( 'data-target', this._options.searchById.dataTarget );
			a.setAttribute( 'data-method', this._options.searchById.dataMethod );
			a.setAttribute( 'data-id', id );
			a.setAttribute( 'data-entity', entity );

			app.handleLinkClick( a );
		},

		/**
		 * Method: _setSelection
		 * @param {Object} aSuggestion
		 */

		_setSelection: function( aSuggestion ) {
			this._suggestion = aSuggestion;
		},

		/**
		 * Method: _clearSelection
		 */

		_clearSelection: function( ) {
			this._suggestion = false;
		},

		/**
		 * Method: _getSelectionPosition
		 */

		_setSelectionPosition: function( ) {
			var el, pos, suggestion;

			if ( this._suggestion !== false && this._suggestion.hasOwnProperty( 'value' ) === true ) {
				suggestion = this._suggestion.value;

				// Only do a replace() if the variable type is a string
				if ( typeof suggestion === 'string' ) {
					suggestion = suggestion.replace( /"/g, '&quot;' );
				}

				el = this.$menu.find( 'div[data-value="' + suggestion + '"]' );
				pos = el.index( ) * el.outerHeight( true );
			}
			else {
				pos = 0;
			}

			this.$menu.find( '> .tt-dataset' ).scrollTop( pos );
		},

		/**
		 * Method: _rebuild
		 */

		_rebuild: function( ) {
			var cache = this._cache.value;

			this.destroy( );

			this.$input.remove( );

			this._input = document.createElement( 'input' );
			this.$input = $( this._input );

			this._input.setAttribute( 'name', this._cache.getAttribute( 'name' ) + '-typeahead' );
			this._input.setAttribute( 'type', 'text' );
			this._input.setAttribute( 'class', this._className );
			this._input.setAttribute( 'autocomplete', 'off' );

			if ( cache.length > 0 ) {
				this._input.setAttribute( 'placeholder', this._encode( cache ) );
			}
			else {
				this._input.setAttribute( 'placeholder', this._encode( this._placeholder ) );
			}

			this._container.appendChild( this._input );

			this._bind( );

			if ( this._options.appendTo !== false ) {
				this.$menu.appendTo( this._options.appendTo );
			}

			if ( cache.length > 0 ) {
				this.select( cache );
			}
		},

		/**
		 * Method: _clearSelection
		 *
		 * Clear the placeholder and focus on the input
		 */

		_clearPlaceholder: function( ) {
			this._input.setAttribute( 'placeholder', '' );
			this.$input.focus( );
		},

		/**
		 * Method: search
		 * @param {Object} aValue
		 */

		search: function( aValue ) {
			var app = this._parent.getApp( ),
				url = this._options.search.url,
				input = this._input.getAttribute( 'name' ).replace( /-typeahead/, '' ),
				self = this,
				data = { },
				error = { },
				found = false,
				i;

			app.getConduit( 'search' ).ajax( {
				url: url,
				data: {
					keywords: aValue,
					view: false
				},
				beforeSend: function( ) {
					self.update( {
						search: [ { label: self._options.search.searchMessage } ]
					} );

					self._clearPlaceholder( );
					self.$menu.css( 'display', 'block' );
				},
				success: function( response ) {
					self._options.search.success.call( self, response );

					if ( response !== '' ) {
						for ( i in response ) {
							if ( self._options.search.mapResponse.hasOwnProperty( i ) === true ) {
								data[ self._options.search.mapResponse[ i ] ] = response[ i ];

								self.update( data );

								found = true;

								break;
							}
						}
					}

					if ( found === false ) {
						self.update( {
							search: [ { label: self._options.search.notFoundMessage } ]
						} );
					}

					self._clearPlaceholder( );
					self.$menu.css( 'display', 'block' );
				},
				error: function( response ) {
					self._options.search.error.call( self, response );

					if ( response.hasOwnProperty( 'validation' ) === true ) {
						for ( i in response.validation ) {
							if ( response.validation[ i ] !== '' ) {
								error[ input ] = response.validation[ i ];

								app.showFormErrors( error );

								break;
							}
						}
					}

					self.update( { } );
					self._clearPlaceholder( );
				}
			} );
		},

		/**
		 * Method: reset
		 */

		reset: function( ) {
			this._clearPlaceholder( );
			this.$input.typeahead( 'val', '' );
			this.$input.val( '' );
			this.$cache.val( '' );
		},

		/**
		 * Method: update
		 * @param {Object} aData
		 */

		update: function( aData ) {
			this._converted = false;
			this._setData( aData );

			this._rebuild( );

			return this;
		},

		/**
		 * Method: select
		 * @param aValue string
		 * @param aByLabel boolean
		 */

		select: function( aValue, aByLabel ) {
			var value = aValue,
				bylabel = aByLabel || false,
				key, i, len, found = false;

			if ( !value && value !== 0 ) {
				value = false;
			}

			key = ( bylabel === true ) ? 'label' : 'value';

			if ( value !== false ) {
				for ( i = 0, len = this._labels.length; i < len; i++ ) {
					if ( this._labels[ i ][ key ] === value ) {
						this.$input.trigger( 'typeahead:select', [ this._labels[ i ], { checkValue: false } ] );

						found = true;

						break;
					}
				}

				if ( found === false && value + '' !== '' ) {
					this.$input.typeahead( 'val', value );

					if ( this._options.hints === true ) {
						this._input.setAttribute( 'placeholder', this._encode( value ) );
						this.$cache.val( value );
					}
				}
			}
			else if ( this._options.hints === true && this._labels.length > 0 ) {
				this.$input.trigger( 'typeahead:select', this._labels[ 0 ] );
			}
		},

		/**
		 * Method: disable
		 * @param {String} aPlaceholder
		 */

		disable: function( aPlaceholder ) {
			var placeholder = aPlaceholder || '';

			this.$input.typeahead( 'destroy' );
			this.$input.val( '' );
			this.$input.addClass( 'typeahead-disabled' );

			this._input.setAttribute( 'name', this._input.getAttribute( 'name' ).replace( /-typeahead/, '' ) );
			this._input.setAttribute( 'placeholder', placeholder );

			this._input.setAttribute( 'disabled', 'disabled' );

			this.$input.data( 'autocomplete', this );
		},

		/**
		 * Method: clear
		 */

		clear: function( ) {
			this.$input.typeahead( 'val', '' );
			this.$cache.val( '' );
			this.select( );
		},

		/**
		 * Method: appendOption
		 * @param {DOMelement} aElement
		 */

		appendOption: function( aElement ) {
			var frag, data;

			if ( $.isElement( aElement ) && aElement.tagName.toLowerCase( ) === 'option' ) {
				frag = document.createDocumentFragment( );
				frag.appendChild( aElement );

				data = this._readOptions( frag );

				this._options.data.push( data );
				this._appendData( data );

				this._rebuild( );
			}
			else if ( aElement instanceof DocumentFragment ) {
				data = this._readOptions( aElement );

				this._options.data.push( data );
				this._appendData( data );

				this._rebuild( );
			}
		},

		/**
		 * Method: getSelection
		 */

		getSelection: function( ) {
			return this._suggestion;
		},

		/**
		 * Destroys the autocomplete instance
		 */

		destroy: function( ) {
			delete this._source;

			this.$menu.remove( );
			this.$input.closest( 'div.modal-body' ).off( 'scroll.Autocomplete' );

			this.$input.typeahead( 'destroy' );
		},

		/**
		 * Resets the autocomplete, move the selection to the first option and put the focus on the autocomplete input
		 */

		resetToFirst: function() {
			this.reset( );
			this.select( '0' );
			this.$input.focus( );
		}
	} );

	return Autocomplete;
} );

